module.exports = __webpack_public_path__ + "media/images/icons/outlined/plus-f6d70cf17c87f92652f2f43e54593ba5.svg";